import { enumOrganizationSortOption } from '@rematter/frontend-lib-api-client';

import { createEntitySelect } from './helpers/createEntitySelect';

import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type SelectableOrganization = QueryAtomResult<
  typeof organizationsQueryAtom
>[number];

const organizationsQueryAtom = createQueryAtomFactory(
  'shared.selectOrganization',
  () => ({
    organizations: {
      __args: {
        sorting: [enumOrganizationSortOption.NameAsc],
        pagination: {
          limit: 10000,
          offset: 0,
        },
      },
      entries: {
        id: true,
        name: true,
        domain: true,
      },
    },
  }),
  {
    select: ({ organizations }) => organizations.entries ?? [],
  },
);

export const SelectOrganization = createEntitySelect(
  'SelectOrganization',
  organizationsQueryAtom,
  {
    formatLabel: (entity) => entity.name,
  },
);
